/* THIS FILE WAS AUTO-GENERATED SEE README.MD AND generation/src/icons FOR MORE DETAILS */
import "./styles.scss";

import PropTypes from "prop-types";
import React from "react";

import { ICON_TYPES, ICON_SIZES } from "../../../constants/icons";

import { IconWrapper } from "./IconWrapper";

export const DocumentIcon = ({ className, iconType, iconSize, ...props }) => {
  if (iconType === ICON_TYPES.OUTLINE) {
    return (
      <IconWrapper
        className={className}
        iconSize={iconSize}
        iconType={iconType}
        iconName="Document"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 11V29H6V3H18L26 11ZM16 5H8V27H24V13H16V5ZM18 5.72928L23.0608 11H18V5.72928Z"
        />
      </IconWrapper>
    );
  }

  if (iconType === ICON_TYPES.FILLED) {
    return (
      <IconWrapper
        className={className}
        iconSize={iconSize}
        iconType={iconType}
        iconName="Document"
        {...props}
      >
        <path d="M16 3H6V29H26V13H16V3Z" />
        <path d="M26 11L18 3V11H26Z" />
      </IconWrapper>
    );
  }

  if (iconType === ICON_TYPES.CIRCLE) {
    return (
      <IconWrapper
        className={className}
        iconSize={iconSize}
        iconType={iconType}
        iconName="Document"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM12.5 10.25H20V17.75H27.5V29.75H12.5V10.25ZM21.5 10.25L27.5 16.25H21.5V10.25Z"
        />
      </IconWrapper>
    );
  }

  return null;
};

DocumentIcon.propTypes = {
  className: PropTypes.string,
  iconType: PropTypes.oneOf(Object.values(ICON_TYPES)),
  iconSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

DocumentIcon.defaultProps = {
  className: undefined,
  iconType: ICON_TYPES.OUTLINE,
  iconSize: ICON_SIZES.MEDIUM,
};
